// Libraries
import styled from 'styled-components'

// Custom
import { Shining } from 'utils/animations'

export const ModalBackground = styled.div`
  position: fixed;
  box-sizing: border-box;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.4);
  z-index: 10;
`

export const Icon = styled.img`
  margin: 0px;
`

export const ModalContainer = styled.div`
  position: absolute;
  box-sizing: border-box;
  padding: 82px 0px 80px 0px;
  height: 295px;
  width: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white00};
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  ${Icon}:nth-child(5) {
    position: absolute;
    left: 48px;
    top: 48px;
    animation: ${Shining} 2s ease-in-out infinite;
  }
  ${Icon}:nth-child(6) {
    position: absolute;
    right: 48px;
    top: 120px;
    animation: ${Shining} 3s ease-in-out 1s infinite;
  }
`

export const Exit = styled.img`
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
`

export const Title = styled.h1`
  margin: 0px;
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.h5};
  color: ${({ theme }) => theme.colors.blueDarkerDefault};
`

export const Text = styled.p`
  margin: 0px;
  color: ${({ theme }) => theme.colors.gray03};
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-size: ${({ theme }) => theme.fontSize.small};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`
